module.exports = __webpack_public_path__ + "img/chat-bot.9d76fee2.svg";